// Generation of the active location. A GET that started in an older
// generation must not be applied after the user switches location.
let locationEpoch = 0;
let stampedLocationId;

export const getLocationEpoch = () => locationEpoch;

// Same id must not bump. configInterseptors also runs on token refresh
// and after the locations list reloads, and those must leave in-flight
// GETs for the current location alone.
export const bumpLocationEpoch = (locationId) => {
  if (locationId === stampedLocationId) {
    return locationEpoch;
  }

  stampedLocationId = locationId;
  locationEpoch += 1;
  return locationEpoch;
};

export const isStaleLocationGet = (method, epoch) =>
  String(method).toLowerCase() === 'get' && epoch !== locationEpoch;

// Never settles. A rejection or an empty return would still enter the
// caller saga's catch, which often writes null or clears loading over
// the location that is current now.
export const pendingLocationRequest = () => new Promise(() => {});
